"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasTeReoTitles = hasTeReoTitles;
exports.TeReoTitles = TeReoTitles;
var config_1 = require("../config");
function TeReoTitles() {
  var TeReoTitlesElements = Array.from(document.querySelectorAll(config_1.CONFIG.teReoTitle.main));
  TeReoTitlesElements.forEach(function (element) {
    return renderTeReoTitle(element);
  });
}
function renderTeReoTitle(element) {
  var parent = element.parentNode;
  var parentType = parent.nodeName.toLocaleLowerCase();
  var newNode = document.createElement('div');
  var TeReoTitleText = element.innerHTML;
  var TeReoTitle = document.createElement('div');
  newNode.classList.add('te-reo-title-wrapper');
  newNode.classList.add("heading-".concat(parentType.slice(1, 2)));
  newNode.appendChild(TeReoTitle);
  TeReoTitle.classList.add('te-reo-title');
  if (element.classList.contains('underline')) {
    TeReoTitle.classList.add('underline');
  }
  TeReoTitle.innerHTML = TeReoTitleText;
  element.remove();
  parent.parentNode.replaceChild(newNode, parent);
  newNode.appendChild(parent);
}
function hasTeReoTitles() {
  if (document.querySelectorAll(config_1.CONFIG.teReoTitle.main).length > 0) {
    return true;
  }
  return false;
}